import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { searchApiRef } from '@backstage/plugin-search-react';
import { InsightsSearchClient } from './InsightsSearchClient';
import { searchSession } from './searchSession';

/**
 * Replaces the search plugin's API client with {@link InsightsSearchClient}.
 *
 * The legacy search plugin is converted by `convertLegacyAppRoot`, which
 * registers its API as `api:search/plugin.search.queryservice`. An app-level
 * factory in `apis.ts` would lose to it (the `search` plugin owns
 * `searchApiRef`), so the override is a `search` plugin module with the same
 * extension id.
 */
export const searchInsightsModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    ApiBlueprint.make({
      name: searchApiRef.id,
      params: defineParams =>
        defineParams({
          api: searchApiRef,
          deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
          factory: ({ discoveryApi, fetchApi }) =>
            new InsightsSearchClient({
              discoveryApi,
              fetchApi,
              session: searchSession,
            }),
        }),
    }),
  ],
});
